import React from 'react';
import '../Styles/styles.css';


const HeroSections = () => {
  return (
    <section id="hero" className="d-flex align-items-center">

      <div className="container">
        <div className="row">
          <div className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
            <h1>MultiMedia Computer Systems</h1>
            <h2>
              Develops commercial software solutions focused on document management and workflow automation for
              Banking, Insurance, and professional sectors like Auditors, Doctors, and Lawyers. We combine top-tier
              security with forms-based architecture to streamline business processes.
            </h2>
            <div className="d-flex justify-content-center justify-content-lg-start" id='link'>
              <a href="#product" className="btn-get-started scrollto">Get Start</a>
              <a href="https://www.youtube.com/watch?v=Lfx1-hLisnw&t=13s" className="glightbox btn-watch-video"><i className="bi bi-play-circle"></i><span>Watch Video</span></a>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">
            <img src="https://res.cloudinary.com/dvypomrpo/image/upload/v1741866203/omdm0tdjrb8zdj4hplga.png" className="img-fluid animated" alt="" />
          </div>
        </div>
      </div>

    </section>
  )
}

export default HeroSections